// Core

// Contrib
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function AlphaHeader(props) {
   const data = props.data;
   var date = new Date(data.Date);

   var icon = "";
   switch (props.data.AlphaHeaderText) {
      case "General":
         icon = "question-circle";
         break;
      case "Accessibility":
         icon = "universal-access";
         break;
      case "Agenda":
         icon = "calendar";
         break;
      case "Live Events & Presentations":
         icon = "person-chalkboard";
         break;
      case "Networking":
         icon = "network-wired";
         break;
      case "1:1 Meet the Experts":
         icon = "handshake";
         break;
      case "Registration & Attendance":
         icon = "address-card";
         break;
      case "Resources":
         icon = "circle-info";
         break;
      case "vFairs Virtual Platform":
         icon = "display";
         break;
   }

   return (
      <Link to={"/" + data.AlphaHeaderText.replace(/\s+/g, "-")}>
         <FontAwesomeIcon icon={icon} size="3x" />
         <p className="itemTitle h3 text-center">
            <strong>{data.AlphaHeaderText}</strong>
         </p>
         Last Update: {date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()}
      </Link>
   );
}

export default AlphaHeader;
